export default {
    login (context, user) {
        context.commit('login', user)
    },
    logout (context) {
        context.commit('logout')
    },
    loadAll (context, force) {
        if (!context.state.dancers.loaded || force) {
            this.dispatch('loadDancers');
        }
        if (!context.state.starterTemplates.loaded || force) {
            this.dispatch('loadStarterTemplates');
        }
        if (!context.state.events.loaded || force) {
            this.dispatch('loadEvents');
        }
        //if (!context.state.registrations.loaded) {
            this.dispatch('loadRegistrations');
        //}
        if (!context.state.starterTypes.loaded || force) {
            this.dispatch('loadStarterTypes');
        }
        if (!context.state.starterStyles.loaded || force) {
            this.dispatch('loadStarterStyles');
        }
        if (!context.state.starters.loaded || force) {
            this.dispatch('loadStarters');
        }

        if (context.state.user.roles.includes('admin')) {
            this.dispatch('loadUsers');
            this.dispatch('loadEventTypes');
            this.dispatch('loadAgeGroups');
        }
    },
    load(context, params) {
        let route = params[0];
        let commitMethod = params[1];
        let itemsKey = params[2];

        this.state[itemsKey].loaded = false;
        axios.get(route)
            .then(response => {
                if (!response.data.success) {
                    return;
                }

                context.commit(commitMethod, response);
                this.state[itemsKey].loaded = true;
            });
    },
    loadDancers (context) {
        context.dispatch('load', ['/api/v1/dancers', 'loadDancers', 'dancers']);
    },
    loadStarterTemplates (context) {
        context.dispatch('load', ['/api/v1/starter_templates', 'loadStarterTemplates', 'starterTemplates']);
    },
    loadStarterTypes (context) {
        context.dispatch('load', ['/api/v1/starter_types', 'loadStarterTypes', 'starterTypes']);
    },
    loadStarterStyles (context) {
        context.dispatch('load', ['/api/v1/starter_styles', 'loadStarterStyles', 'starterStyles']);
    },
    loadEvents (context) {
        context.dispatch('load', ['/api/v1/events', 'loadEvents', 'events']);
    },
    loadRegistrations (context) {
        context.dispatch('load', ['/api/v1/event_registrations', 'loadRegistrations', 'registrations']);
    },
    loadUser (context) {
        context.dispatch('load', ['/api/v1/users/me', 'loadUser', 'user']);
    },
    loadUsers (context) {
        context.dispatch('load', ['/api/v1/users', 'loadUsers', 'users']);
    },
    loadEventTypes (context) {
        context.dispatch('load', ['/api/v1/event_types', 'loadEventTypes', 'eventTypes']);
    },
    loadAgeGroups (context) {
        context.dispatch('load', ['/api/v1/age_groups', 'loadAgeGroups', 'ageGroups']);
    },
    loadStarters (context) {
        context.dispatch('load', ['/api/v1/starters', 'loadStarters', 'starters']);
    }
}
